import Vue from 'vue';
import { getLocationObj, isXL } from './utils';
import { RESULT_TEXT } from './constants/index';
import {
  getPageInfo,
  getInviteeCode,
  fetchCounponDetail,
  getLoginInfo,
  getXlUserMinuCode
} from './api/index';

import { getUrlParam } from '@/utils';

function getInfo(data, key) {
  return data.pages.find(item => item.pageName === key);
}
const state = {
  role: 1,
  actData: {},
  posterData: {},
  tplData: {},
  // 地理坐标
  position: {},
  locationObj: {},
  // 城市id
  city_id: '',
  // 客户端ip
  client_ip: '',
  // 活动code
  activityCode: '',
  isDisablePage: false,
  //  是否命中风控
  is_risk: false,
  // 邀请码
  shareCode: '',
  businessType: 0, // 0 司机邀用户 1 客推客
  metaInfo: {},
  beInvitedType: 0, // 0:禁止分享 1:用户 2:司机
  loginConfig: null,
  xlUserMinuCode: null
};
const getters = {
  configInfo(state) {
    return state.active_invite.data;
  }
};
const mutations = {
  setLocationObj(state, value) {
    state.locationObj = value;
  },
  set_role(state, value) {
    state.role = value;
  },
  setActData(state, val) {
    state.actData = val;
  },
  setTplData(state, val) {
    state.tplData = val;
  },
  setPageDisable(state) {
    state.isDisablePage = true;
  },
  // 设置地理坐标
  setPosition(state, value) {
    state.position = value;
  },
  // 设置城市id
  setCity_id(state, value) {
    state.city_id = value;
  },
  // 设置客户端ip
  setClient_ip(state, value) {
    state.client_ip = value;
  },
  // 设置活动code
  setActivityCode(state, value) {
    state.activityCode = value;
  },
  // 设置风控
  setIs_risk(state, value) {
    state.is_risk = value;
  },
  // 设置邀请码
  setShareCode(state, value) {
    state.shareCode = value;
  },
  // 设置分享海报数据
  setPosterData(state, value) {
    state.posterData = value;
  },
  // 设置分享海报数据
  setBusinessType(state, value) {
    state.businessType = value;
  },
  // 设置模版数据
  setMetaInfo(state, value) {
    state.metaInfo = value;
  },
  // 设置应该邀请哪类角色 1、用户 2、司机
  setBeInvitedType(state, value) {
    state.beInvitedType = value;
  },
  // 设置登陆页面的配置信息
  setLoginConfig(state, value) {
    state.loginConfig = value;
  },
  setXlUserMinuCode(state, value) {
    state.xlUserMinuCode = value;
  }
};
const actions = {
  /**
   * @param {boolean} isHideLoading: 是否隐藏loading动画
   */
  async loadLocationData({ commit }, isHideLoading) {
    const locationObj = await getLocationObj(isHideLoading);
    if (locationObj.city_id) {
      locationObj.cityId = locationObj.city_id;
      delete locationObj.city_id;
    }
    commit('setLocationObj', locationObj);
  },
  /**
   * @param {Object} locationInfo 地理位置信息
   * @param {String} activityId 活动id
   * @param {String} code 活动模版
   */
  async fetchShareCode({ commit }, params) {
    Vue.prototype.$hll.showLoading({ disableLogo: isXL() });
    try {
      const res = await getInviteeCode({ ...params });
      commit('setShareCode', res);
    } catch (error) {
      throw error;
    } finally {
      Vue.prototype.$hll.hideLoading();
    }
  },
  async fetchXlUserMinProCode({ commit }, params) {
    Vue.prototype.$hll.showLoading({ disableLogo: isXL() });
    try {
      const res = await getXlUserMinuCode({ ...params });
      commit('setXlUserMinuCode', res);
    } catch (error) {
      throw error;
    } finally {
      Vue.prototype.$hll.hideLoading();
    }
  },
  async fetchLoginInfo({ commit }) {
    Vue.prototype.$hll.showLoading({ disableLogo: isXL() });
    let res;
    try {
      res = await getLoginInfo({
        code: 'login_config_page',
        templateCode: getUrlParam('code')
      });
      commit('setLoginConfig', res);
    } catch (error) {
      throw error;
    } finally {
      Vue.prototype.$hll.hideLoading();
    }
  },
  async fetchPageInfo({ commit, dispatch }, params) {
    Vue.prototype.$hll.showLoading({ disableLogo: isXL() });
    let actData;
    try {
      actData = await getPageInfo({ ...params });
    } catch (error) {
      throw error;
    } finally {
      Vue.prototype.$hll.hideLoading();
    }
    let metaInfo = {};
    let homeMetaInfo = {};
    let postInfo = {};
    try {
      let _metaInfo = actData.metaInfo.replace(/\\/g, '');
      metaInfo = JSON.parse(_metaInfo);
      homeMetaInfo = getInfo(metaInfo, 'home');
      postInfo = getInfo(metaInfo, 'poster');
    } catch (e) {
      console.log(e);
      throw new Error('模板数据 parse 出错');
    }
    if (!actData.taskInfos) {
      actData.taskInfos = [];
    } else {
      // 设置分享给哪类角色
      let filterTaskInfos = actData.taskInfos.filter(
        item => item.category === 1
      );
      if (filterTaskInfos.length > 0) {
        let userType = filterTaskInfos[0].userType;
        commit('setBeInvitedType', userType);
      }
    }
    // 奖品数据处理
    commit('setActData', {
      ...actData
    });
    commit('setMetaInfo', metaInfo);
    commit('setPosterData', postInfo);
    commit('setTplData', homeMetaInfo);
    let tipCode = actData.result || '';
    if (tipCode != 'SUCCESS') {
      commit('setPageDisable');
      Vue.prototype.$hll.toast(RESULT_TEXT[tipCode]);
    } else {
      // 活动时间检查
      dispatch('actTimeCheck', actData);
    }
  },
  actTimeCheck({ commit }, actData) {
    const { startTime, endTime, currentTime: now } = actData;
    if (now < startTime) {
      Vue.prototype.$hll.toast('活动未开始');
      commit('setPageDisable');
      return false;
    }
    if (now > endTime) {
      Vue.prototype.$hll.toast('活动已结束');
      commit('setPageDisable');
      return false;
    }
    return true;
  },
  async getCounponDetail(_, couponCode) {
    try {
      const res = await fetchCounponDetail({
        rewardCode: couponCode, // 奖励码
        rewardType: 4 //权益的类型 4-卡券
      });
      return res;
    } catch (error) {
      throw error;
    }
  }
};
export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
